import { cx } from "@/utils/cx";
import signet from "@/assets/firstier-signet.svg";
import logoDark from "@/assets/firstier-logo-dark.svg";
import logoLight from "@/assets/firstier-logo-light.svg";

/**
 * Canonical Firstier lockup (qadar-assets/brand/logos/firstier, original files).
 * The light-mode file carries dark ink; the dark-mode file carries light ink.
 */
export function FirstierLogo({ className }: { className?: string }) {
  return (
    <>
      <img src={logoLight} alt="Firstier" className={cx("dark:hidden", className)} />
      <img src={logoDark} alt="Firstier" className={cx("hidden dark:block", className)} />
    </>
  );
}

/** Square Firstier signet (brand-identical mark) for compact spaces such as the slim rail. */
export function FirstierSignet({ className }: { className?: string }) {
  return <img src={signet} alt="Firstier" className={className} />;
}
